/*
|==========================================================================
| WordPress + Foundation
|==========================================================================
| 
| These functions make sure WordPress and Foundation play nice together,
| and this is also where we declare functions defined in this folder.
|
|==========================================================================
|
*/

let selectedProductIds = [''];

let cartLines;

let cartId = '';

let checkoutUrl = '';

const maxQuantities = {
  '8181709570244': 1, // Set the max quantity for product ID 8181709570244
  '8181709701316': 1  // Set the max quantity for product ID 8181709701316
};

document.addEventListener( "DOMContentLoaded", function() {

  // let productsAddedList = sessionStorage.getItem("productsAdded") ? JSON.parse(sessionStorage.getItem("productsAdded")) : [];

  // Evolving function for WCAG guidelines
  // v8_wcag();

  // Detect browser and device
  // detectBrowserAndDevice();

  // Enable skrollr
  // var s = skrollr.init();

  // Gravity Forms Placeholder Clearing
  // gravity_forms_placeholders();

  // Inline SVG replacement
  // inline_svg_replacement();

  // Isotope Masonry
  // isotope_masonry();

  // TablePress Cleanup
  // tablepress();

  // Call this function to update the cart count
  // updateShopifyCartCount();  

  jQuery('.slider').slick({
      dots: false,
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true
  });

  jQuery('.slider-card').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true
  });

  jQuery('.slider-3').slick({
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: true,
    draggable: true,
    // centerMode: true,
  });

  jQuery('body:not(.page-template-template-landing-page-superfan-2025) .slider-review').slick({
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 3,
    adaptiveHeight: false,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  jQuery('body:not(.page-template-template-landing-page-superfan-2025) .slider-sales').slick({
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 2,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  jQuery('body.page-template-template-landing-page-superfan-2025 .slider-review').slick({
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 2,
    adaptiveHeight: false,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: true,
  });

  jQuery('body.page-template-template-landing-page-superfan-2025 .slider-sales').slick({
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  });

  if(jQuery('#countdown').length > 0) {
    const targetDateString = jQuery('#countdown').data('target');
    console.log('Target date string:', targetDateString);
    const targetDate = new Date(targetDateString);
    console.log('Target date object:', targetDate);

    if (isNaN(targetDate.getTime())) {
      console.error('Invalid target date:', targetDateString);
    } else {
      startCountdown(targetDate,'countdown');
    }
  }

  if(jQuery('#countdownTop').length > 0) {
    const targetDateString = jQuery('#countdownTop').data('target');
    console.log('Target date string:', targetDateString);
    const targetDate = new Date(targetDateString);
    console.log('Target date object:', targetDate);

    if (isNaN(targetDate.getTime())) {
      console.error('Invalid target date:', targetDateString);
    } else {
      startCountdown(targetDate,'countdownTop');
    }
  }

  // jQuery('.zoom-image').magnify();

  // If is homepage
  if(jQuery('.page-template-template-home').length > 0) {
    
    // Attach scroll event listener
    jQuery(window).on('scroll', checkScroll);

    // Event listener for when the modal is closed
    // jQuery('#myModal').on('closed.zf.reveal', function() {
    //   setSessionCookie("modalClosed", "true");  // Set session cookie when modal is closed
    // });


  } 


  // Example usage on button click
  jQuery(".add-to-cart").click(function(){
    const cartId = localStorage.getItem('shopifyCartId');
    // console.log(cartId); 
    const variantId = jQuery(this).data('product');
    if(cartId) {
      addProductToExistingCart(cartId, variantId, 1);
    } else {
      addToCart(variantId);
    }
    if(maxQuantities[variantId]) {
      jQuery(this).prop('disabled', true);

      // Add product ID if not already in cart
      if (!productsAddedList.includes(variantId)) {
          productsAddedList.push(variantId);
          sessionStorage.setItem("productsAdded", JSON.stringify(productsAddedList));
      }

    }
  });

  jQuery(document).on('click', '.cart-remove-button', function () {
    const lineId = jQuery(this).data('line-id');
    // console.log(lineId);
    removeCartItem(lineId);
  });

  if(jQuery('.page-template-template-landing-page-superfan').length > 0 || jQuery('.page-template-template-landing-page-superfan-v2').length > 0) {

    // Step 1: Extract product IDs dynamically from the HTML elements
    const fetchSelectedProductIds = jQuery('.product').map(function () {
      return this.id; // Collect the ID of each product element
    }).get(); // Convert jQuery collection to a plain array

    // console.log(fetchSelectedProductIds);

    if(fetchSelectedProductIds.length > 0) {
      selectedProductIds = fetchSelectedProductIds;
      fetchAllProducts(function (products) {
        // Display product titles in an alert (or handle them however you need)
        // console.log(products);
        injectProductData(products);
      });
    }     

  }

  if(jQuery('.page-template-template-landing-page-superfan-2025').length > 0) {

    // Step 1: Extract product IDs dynamically from the HTML elements
    const fetchSelectedProductIds = jQuery('.product').map(function () {
      return this.id; // Collect the ID of each product element
    }).get(); // Convert jQuery collection to a plain array

    // console.log(fetchSelectedProductIds);

    if(fetchSelectedProductIds.length > 0) {
      selectedProductIds = fetchSelectedProductIds;
      fetchAllProducts(function (products) {
        // Display product titles in an alert (or handle them however you need)
        // console.log(products);
        injectProductData(products,true);
      });
    }     

  }

  cartId = localStorage.getItem('shopifyCartId'); // Fetch cart ID from localStorage
  checkoutUrl = localStorage.getItem('checkoutUrl');

  if (!cartId) {
    console.warn('No cart ID found.');
    return;
  } else {
    fetchCart(cartId, false);
  }

  // Attach event listeners to the plus and minus buttons
  // jQuery(document).on('click', '.quantity__button[name="plus"]', function () {
  //   const lineId = jQuery(this).data('line-id');
  //   const input = jQuery(this).siblings('.quantity__input');
  //   const newQuantity = parseInt(input.val(), 10) + 1;

  //   input.val(newQuantity); // Update input field visually
  //   updateCartLineQuantity(cartId, lineId, newQuantity);
  // });

  // jQuery(document).on('click', '.quantity__button[name="minus"]', function () {
  //   const lineId = jQuery(this).data('line-id');
  //   const input = jQuery(this).siblings('.quantity__input');
  //   const newQuantity = Math.max(1, parseInt(input.val(), 10) - 1); // Prevent going below 1

  //   input.val(newQuantity); // Update input field visually
  //   updateCartLineQuantity(cartId, lineId, newQuantity);
  // });

  var pages_need_plyr = [".page-template-template-landing-page-superfan-v2", ".page-template-template-landing-page-superfan-2025"];

  for (var i = 0; i < pages_need_plyr.length; i++) {
      if (jQuery(pages_need_plyr[i]).length > 0) {
          const player = new Plyr('#player');
          // player.enableTextTrack('en');
          player.on('ended', function (event) {
              player.restart();
              // players[0].play(); // infinite loop
          });
      }
  }

});

/*
|==========================================================================
| Use this function to fire events after the entire window has loaded,
| including images and CSS files.
|==========================================================================
*/

window.onload = function() {
  AOS.init({

  // Global settings:
  disable: 'mobile', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  // startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  // initClassName: 'aos-init', // class applied after initialization
  // animatedClassName: 'aos-animate', // class applied on animation
  // useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  // disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  // debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  // throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  // offset: 120, // offset (in px) from the original trigger point
  // delay: 0, // values from 0 to 3000, with step 50ms
  // duration: 400, // values from 0 to 3000, with step 50ms
  // easing: 'ease', // default easing for AOS animations
  // once: false, // whether animation should happen only once - while scrolling down
  // mirror: false, // whether elements should animate out while scrolling past them
  // anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation);
});

};

function checkScroll() {

  // Check if the modal has already been shown this session
  if (getSessionCookie("modalClosed") === "true") {
    return;  // Do not show the modal again if it's already been closed
  }

  // Check if the user has given consent using iubenda cookies
  if (!iubendaConsentGiven()) {
    return;  // Do not show the modal if consent is not given
  }

    const scrollPosition = window.scrollY;
    const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrolledPercentage = (scrollPosition / documentHeight) * 100;

    if (scrolledPercentage >= 20) {
        if(iubendaConsentGiven()) {
          // jQuery('#myModal').foundation('open');  // Open the modal when 20% is scrolled
          jQuery(window).off('scroll', checkScroll);  // Remove scroll event listener after showing the modal
        }
        
    }
}

// Function to check if iubenda consent is given
function iubendaConsentGiven() {
  // Replace with actual logic to check iubenda consent
  return typeof _iub !== "undefined" && _iub.cs.consent.consent;
}

// Helper function to manage session cookies
function setSessionCookie(name, value) {
  document.cookie = name + "=" + value + "; path=/"; // No expiration, session cookie
}

function getSessionCookie(name) {
  let cookieArr = document.cookie.split(";");
  for (let i = 0; i < cookieArr.length; i++) {
      let cookiePair = cookieArr[i].split("=");
      if (name == cookiePair[0].trim()) {
          return decodeURIComponent(cookiePair[1]);
      }
  }
  return null;
}

const shopifyDomain = 'shop.bobattlearena.com';
const storefrontAccessToken = '0e7e8658a130ecbdd39c3ba9bf310e0c';

function addToCart(variantId, quantity = 1) {
  jQuery.ajax({
    url: `https://${shopifyDomain}/api/2023-10/graphql.json`,
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
    },
    data: JSON.stringify({
      query: `
        mutation {
          cartCreate(input: {
            lines: [{ quantity: ${quantity}, merchandiseId: "${variantId}" }]
          }) {
            cart {
              id
              checkoutUrl
            }
          }
        }
      `,
    }),
    success: function (response) {
      const getCheckoutUrl = response.data.cartCreate.cart.checkoutUrl;
      const id = response.data.cartCreate.cart.id;
       // Cross-Domain Communication
      // const shopIframe = document.getElementById('shop-iframe');
      // shopIframe.contentWindow.postMessage({ cartId: id }, 'https://shop.bobattlearena.com');
      localStorage.setItem('shopifyCartId', id);
      localStorage.setItem('checkoutUrl', getCheckoutUrl);
      checkoutUrl = getCheckoutUrl;
      // window.location.href = checkoutUrl; // Redirect to checkout
      fetchCart(id, true);
    },
    error: function (error) {
      console.error('Error adding to cart:', error);
      alert('Something went wrong. Please try again.');
    },
  });
}


function fetchAllProducts(callback) {
  const query = `
  {
    products(first: 50) {
      edges {
        node {
          id
          title
          description
          descriptionHtml
          handle
          totalInventory
          variants(first: 10) {
            edges {
              node {
                id
                title
                price: priceV2 {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
  }
  `;

  jQuery.ajax({
    url: `https://${shopifyDomain}/api/2023-10/graphql.json`,
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
    },
    data: JSON.stringify({ query }),
    success: function (response) {
      const products = response.data.products.edges.map(edge => edge.node);

      if (callback) callback(products); // Optional callback to process products
    },
    error: function (error) {
      console.error('Error fetching products:', error);
    },
  });
}

// Function to inject product data into HTML
function injectProductData(products,is2025 = false) {
  products.forEach(product => {

    const productId = product.id.split('/').pop(); 

    if (selectedProductIds.includes(productId)) {

      // Find the matching product element on the page
      const $productElement = jQuery(`#${productId}`);
      const $productModalElement = jQuery(`#modal-${productId}`);

      // console.log($productModalElement);

      if ($productElement.length) {
        // Inject the price from the first variant
        const firstVariant = product.variants.edges[0]?.node;
        if (firstVariant) {
          const formattedPrice = formatPrice(firstVariant.price.amount);
          $productElement.find('.price').text(formattedPrice);
          $productElement.find('.add-to-cart').attr('data-product', firstVariant.id);
          $productElement.find('.currentInventory').text(product.totalInventory);
          $productElement.find('.add-to-cart.sold-out').text('Sold Out');
          $productElement.find('.add-to-cart.sold-out').prop('disabled', true);
        }

        if(product.description) {
          // console.log(product.description);
          $productModalElement.find('.description').html(product.descriptionHtml);
        }

        if(product.totalInventory === 0) {
          if(!is2025) {
            $productElement.find('.box-details').text('How can I get this box?');
            $productElement.find('.add-to-cart').prop('disabled', true);
            $productElement.find('.add-to-cart').remove();
            $productElement.find('h2.blue-1').parent().append('<button class="btn-blue-1 disabled" disabled>Not Available</button>');
          }
        }

        // if(is2025 && productsAddedList?.length > 0 && productsAddedList?.includes(productId)) {
        //   $productElement.find('.add-to-cart').prop('disabled', true);
        // }

      }
        
    }
  });
  
}

// Price formatting function
function formatPrice(amount) {
  const price = parseFloat(amount);
  if (price % 1 === 0) {
    // If the price is a whole number (e.g., 85.0), return it without decimals
    return price.toFixed(0);
  } else {
    // If the price has decimals, ensure it has .50
    return price.toFixed(2).endsWith('.00') ? price.toFixed(0) : price.toFixed(2);
  }
}

function addDecimal(amount) {
  const price = parseFloat(amount);
  return price.toFixed(2);
}

// Function to clean the product_id
function stringToSlug(input) {
  // Split the string by '/' and get the last part
  let parts = input.split('/');
  let lastPart = parts[parts.length - 1];

  // Convert to lowercase (if needed) and return the slug
  return lastPart.toLowerCase();
}

function fetchCart(cartId, openCart) {

  cartId = localStorage.getItem('shopifyCartId');

  const query = `
    query GetCart($cartId: ID!) {
      cart(id: $cartId) {
        id
        totalQuantity
        lines(first: 50) {
          edges {
            node {
              id
              quantity
              merchandise {
                ... on ProductVariant {
                  id
                  title
                  product {
                    title
                    description
                  }
                }
              }
              cost {
                totalAmount {
                  amount
                  currencyCode
                }
              }
              attributes {
                key
                value
              }
            }
          }
        }
        attributes {
          key
          value
        }
        estimatedCost {
          subtotalAmount {
            amount
            currencyCode
          }
          totalAmount {
            amount
            currencyCode
          }
        }
      }
    }
  `;

  jQuery.ajax({
    url: `https://${shopifyDomain}/api/2023-10/graphql.json`,
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
    },
    data: JSON.stringify({ query, variables: { cartId } }),
    success: function (response) {
      if (response.data && response.data.cart) {
        // console.log(response.data.cart);
        const count = response.data.cart.totalQuantity;
        if(count > 0) {
          cartLines = createLinesArray(response.data.cart);
          jQuery('.cart-drawer__empty-content').addClass('hide');
          displayCartContents(response.data.cart, openCart);
          document.querySelector('.shopify-cart-count').textContent = count;
          jQuery('.shopify-cart-count').removeClass('hide');
          jQuery('#cart-container').removeClass('hide');

          // Reset all buttons (in case products are removed)
          // resetCartButtons();

          // Disable buttons for items already in the cart
          // disableCartButtons(response.data.cart.lines.edges);
        } else {
          jQuery('.cart-drawer__empty-content.hide').removeClass('hide');
          document.querySelector('.shopify-cart-count').textContent = '';
          jQuery('.shopify-cart-count').addClass('hide');
          jQuery('#cart-container').addClass('hide');
          jQuery('#tablerows').empty();
          jQuery('#drawer__footer').empty();
          // resetCartButtons();

          localStorage.removeItem('shopifyCartId');
          localStorage.removeItem('checkoutUrl');
          
        }
      } else {
        jQuery('.cart-drawer__empty-content.hide').removeClass('hide');
        document.querySelector('.shopify-cart-count').textContent = '';
        jQuery('.shopify-cart-count').addClass('hide');

        console.warn('Cart not found or is empty.');

        // Reset all buttons (in case products are removed)
        // resetCartButtons();
      }
    },
    error: function (error) {
      console.error('Error fetching cart:', error);
    },
  });
}

function displayCartContents(cart, openCart) {
  const $linesContainer = jQuery('#tablerows');
  const $drawer__footer = jQuery('#drawer__footer'); // Assuming you have a cart container in HTML
  $linesContainer.empty(); // Clear previous contents
  $drawer__footer.empty();

  const lineItems = cart.lines.edges.map(edge => edge.node);

  lineItems.forEach(item => {
    const { id, quantity, merchandise, cost } = item;
    const { product, title } = merchandise;
    const { totalAmount } = cost;
    const productTitle = product.title;
    const priceItem = addDecimal(totalAmount?.amount);
  

    $linesContainer.append(`
    <tr class="cart-item" role="row">
      <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><span class="cart-item__name h4 break">${productTitle}</span><div class="product-option">
        $${priceItem}
          </div>
      </td>

      <td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">

  
  <div class="cart-item__price-wrapper"><span class="price price--end">
              $${priceItem}
            </span></div>
      </td><td class="cart-item__quantity " role="cell" headers="CartDrawer-ColumnQuantity">
        <quantity-popover>
          <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
            <div class="quantity-popover-container">
              <div class="quantity cart-quantity">
                <button data-line-id="${id}" class="quantity__button quantity-down" name="minus" type="button">
                  <span class="show-for-sr">Decrease quantity</span>
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
  </path></svg>

                </button>
                <input class="quantity__input" type="number" value="${quantity}" ${maxQuantities[id] ? `max="${maxQuantities[id]}"` : ''}>
                <button data-line-id="${id}" class="quantity__button" name="plus" type="button" ${maxQuantities[id] && quantity >= maxQuantities[id] ? 'disabled' : ''}>
                  <span class="show-for-sr">Increase quantity</span>
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
  </path></svg>

                </button>
              </div>
            </div>
            <div class="cart-remove-button">
              <button type="button" class="button button--tertiary cart-remove-button" aria-label="Remove" data-line-id="${id}">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
  <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
  <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
  </svg>

              </button>
              </div>
            
          </div>
      </td>
    </tr>
    `);

    // Attach event listeners after appending the HTML
    $linesContainer.find('.quantity__button').on('click', function() {
      const cartId = localStorage.getItem('shopifyCartId');
      const lineId = jQuery(this).data('line-id');
      const action = jQuery(this).attr('name');
      // Handle the button click event here
      if (action === 'minus') {
        // Decrease quantity logic
        const input = jQuery(this).siblings('.quantity__input');
        const newQuantity = Math.max(1, parseInt(input.val(), 10) - 1); // Prevent going below 1

        input.val(newQuantity); // Update input field visually
        updateCartLineQuantity(cartId, lineId, newQuantity);
      } else if (action === 'plus') {
        // Increase quantity logic
        const input = jQuery(this).siblings('.quantity__input');
        const newQuantity = parseInt(input.val(), 10) + 1;

        input.val(newQuantity); // Update input field visually
        updateCartLineQuantity(cartId, lineId, newQuantity);
      }
    });

    $linesContainer.find('.cart-remove-button').on('click', function() {
      const lineId = jQuery(this).data('line-id');
      // Handle the remove button click event here
      // console.log(lineId);
      removeCartItem(lineId);
    });

  });

  const { subtotalAmount, totalAmount } = cart.estimatedCost;
  $drawer__footer.append(`
    <div class="cart-drawer__footer">
        <div></div>

        <div class="totals" role="status">
          <h2 class="totals__total fw9 ttu">Estimated total</h2>
          <p class="totals__total-value">$${addDecimal(totalAmount.amount)} ${totalAmount.currencyCode}</p>
        </div>

        <small class="tax-note caption-large rte">Taxes included. Shipping calculated at checkout.
    </small>
      </div>

      <!-- CTAs -->

      <div class="cart__ctas flex-wrap">
        <button id="CartDrawer-Checkout" class="cart__checkout-button button" name="checkout">
          Check out
        </button>
        <button data-close class="btn" >
          Continue Shopping
        </button>
      </div>
  `);

  // Add event listener for button click
  document.getElementById("CartDrawer-Checkout").addEventListener("click", () => {
    window.location.href = checkoutUrl;
  });

  if(openCart) {
    jQuery('#off-canvas-cart').foundation('open');
  }
  
}

// UpdateCart
function updateCart(cartId, lines) {
  const query = `
      mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
          cartLinesUpdate(cartId: $cartId, lines: $lines) {
              cart {
                  id
                  lines {
                      id
                      quantity
                      merchandise {
                          ... on ProductVariant {
                              id
                              title
                              priceV2 {
                                  amount
                                  currencyCode
                              }
                          }
                      }
                  }
              }
              userErrors {
                  field
                  message
              }
          }
      }
  `;

  const variables = {
      cartId: cartId,
      lines: lines,
  };

  jQuery.ajax({
      url: `https://${shopifyDomain}/api/2023-10/graphql.json`,
      type: 'POST',
      contentType: 'application/json',
      headers: {
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
      data: JSON.stringify({ query: query, variables: variables }),
      success: function(response) {
          // console.log('Cart updated successfully:', response);
          // Handle the updated cart response here
      },
      error: function(jqXHR, textStatus, errorThrown) {
          console.error('Error updating cart:', textStatus, errorThrown);
          // Handle error response here
      }
  });
}

// Create Cart Products Lines
function createLinesArray(cartResponse) {
  const lines = cartResponse.lines.edges.map(edge => ({
      id: edge.node.id, // Cart line ID
      quantity: edge.node.quantity // Quantity
  }));
  return lines;
}

// Add new product to existing cart
function addProductToExistingCart(cartId, variantId, quantity) {
  const query = `
      mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
          cartLinesAdd(cartId: $cartId, lines: $lines) {
              cart {
                id
                lines (first:10){
                  nodes {
                      quantity
                      merchandise {
                          ... on ProductVariant{
                              id
                          }
                      }
                  }
                }
              }
              userErrors {
                  field
                  message
              }
          }
      }
  `;

  const variables = {
      cartId,
      lines: [
          {
              merchandiseId: variantId, // Use merchandiseId for the product variant
              quantity: quantity, // Quantity to add
              attributes: []
          }
      ],
  };

jQuery.ajax({
      url: `https://${shopifyDomain}/api/2023-10/graphql.json`, // Storefront API endpoint
      type: 'POST',
      contentType: 'application/json',
      headers: {
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken, // Use Storefront Access Token
      },
      data: JSON.stringify({ query: query, variables: variables }),
      success: function(response) {
          // console.log('Product added to cart successfully:', response);
          fetchCart(response.data.cartLinesAdd.cart.id, true);
          // Handle the updated cart response here
      },
      error: function(jqXHR, textStatus, errorThrown) {
          console.error('Error adding product to cart:', textStatus, errorThrown);
          // Handle error response here
      }
  });
}

// Function to remove an item from the cart using GraphQL
function removeCartItem(lineId) {
  const cartId = localStorage.getItem('shopifyCartId'); // Fetch cart ID from localStorage
  const query = `
    mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
      cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
        cart {
          id
          lines(first: 10) {
            edges {
              node {
                id
                quantity
              }
            }
          }
        }
      }
    }
  `;

  const variables = {
    cartId: cartId,
    lineIds: [lineId]
  };

  jQuery.ajax({
    url: `https://${shopifyDomain}/api/2023-10/graphql.json`, // Storefront API endpoint
    type: 'POST',
    contentType: 'application/json',
    headers: {
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken, // Use Storefront Access Token
    },
    data: JSON.stringify({ query: query, variables: variables }),
    success: function (response) {
      if (response.errors) {
        console.error('Error removing item:', response.errors);
      } else {
        // console.log('Item removed:', response.data);
        // Optionally refresh the cart UI
        fetchCart(cartId);
      }
    },
    error: function (xhr, status, error) {
      console.error('Network error:', error);
    }
  });
}


// Disable buttons for merchandise items already in the cart
function disableCartButtons(cartEdges) {
  cartEdges.forEach(({ node }) => {
    // console.log(node);
    const merchandiseId = node.merchandise.id;
    const button = document.querySelector(`button[data-product="${merchandiseId}"]`);

    if (button) {
      button.disabled = true;
      button.classList.add('disabled');
      // console.log(`Disabled button for product: ${merchandiseId}`);
    } 

  });
}

// Re-enable all buttons
function resetCartButtons() {
  const buttons = document.querySelectorAll('button.add-to-cart.disabled');
  buttons.forEach((button) => {
    button.disabled = false;
    button.classList.remove('disabled');
    // console.log(`Re-enabled button: ${button.dataset.product}`);
  });
}

// Function to update the cart line quantity
function updateCartLineQuantity(cartId, lineId, quantity) {
  const query = `
    mutation UpdateCartLine($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart {
          id
          lines(first: 50) {
            edges {
              node {
                id
                quantity
                merchandise {
                  ... on ProductVariant {
                    id
                  }
                }
              }
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const variables = {
    cartId,
    lines: [
      {
        id: lineId,
        quantity: quantity,
      },
    ],
  };

  jQuery.ajax({
    url: `https://${shopifyDomain}/api/2023-10/graphql.json`,
    method: 'POST',
    contentType: 'application/json',
    headers: {
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
    },
    data: JSON.stringify({ query, variables }),
    success: function (response) {
      if (response.data && response.data.cartLinesUpdate.userErrors.length === 0) {
        console.log('Quantity updated:', response.data.cart);
        fetchCart(cartId, true); // Refresh cart to reflect changes
      } else {
        console.error('Error updating quantity:', response.data.cartLinesUpdate.userErrors);
      }
    },
    error: function (error) {
      console.error('Error with request:', error);
    },
  });
}

function startCountdown(targetDate, elementId) {
  const countdownElement = document.getElementById(elementId);

  if (!countdownElement) {
    console.error('Countdown element not found');
    return;
  }

  if (!(targetDate instanceof Date) || isNaN(targetDate.getTime())) {
    console.error('Invalid target date');
    return;
  }

  function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      if (distance < 0) {
          clearInterval(interval);
          countdownElement.innerHTML = "EXPIRED";
          return;
      }

      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      countdownElement.innerHTML = `${hours} hours ${minutes} minutes`;
      countdownElement.innerHTML = `<span class="hours">${hours} <span class="countdown-label ttu">hours</span></span> <span class="minutes">${minutes} <span class="countdown-label ttu">minutes</span> </span> <span class="seconds">${seconds} <span class="countdown-label ttu">seconds</span>`;
  }

  const interval = setInterval(updateCountdown, 1000);
  updateCountdown(); // Initial call to display the countdown immediately
}

function getProductAdded() {
  return sessionStorage.getItem("productsAdded") ? JSON.parse(sessionStorage.getItem("productsAdded")) : [];
}